import React from 'react';

const SuccessMessage = ({ domain, langs }) => {
  return (
    <div style={{
      marginTop: '10%',
      textAlign: 'center'
    }}>
      <div>
        <h1>
          <i 
            className="fas fa-check" 
            style={{ 
              fontSize: '56px', 
              color: '#28a745' 
            }} 
            aria-hidden="true"
          ></i>
        </h1>
        <br />
        <div style={{ 
          width: '40%', 
          margin: '0 auto',
          fontSize: '18px',
          lineHeight: '1.6'
        }}>
          {langs.yourEmail} <br />
          {langs.success}
        </div>
        <br />
        <a 
          href="#" 
          style={{ 
            fontSize: '15px', 
            fontWeight: 'initial', 
            display: 'block',
            color: '#6c757d'
          }}
        >
          Copyright © {domain} 2025
        </a>
      </div>
    </div>
  );
};

export default SuccessMessage;